import React from 'react';
import { FiInstagram, FiFacebook } from 'react-icons/fi';
import { SiTiktok } from 'react-icons/si';
import { siteData } from '../../data/content';

const socialItems = [
  {
    label: 'Facebook',
    icon: FiFacebook,
    key: 'facebook',
    handle: '@AREliteDetailing',
  },
  {
    label: 'Instagram',
    icon: FiInstagram,
    key: 'instagram',
    handle: '@a.r.elite_detailing',
  },
  {
    label: 'TikTok',
    icon: SiTiktok,
    key: 'tiktok',
    handle: '@arelitedetailing',
  },
];

export default function SocialLinks({ variant = 'default' }) {
  if (variant === 'icons') {
    return (
      <div className="flex items-center gap-3">
        {socialItems.map(({ label, icon: Icon, key }) => (
          <a
            key={key}
            href={siteData.business.socials[key]}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={label}
            className="w-10 h-10 rounded-full bg-slate-900 border border-slate-800 flex items-center justify-center text-slate-400 hover:bg-blue-600 hover:text-white hover:border-blue-500 transition-all duration-200"
          >
            <Icon className="text-base" />
          </a>
        ))}
      </div>
    );
  }

  return (
    <div className="flex flex-wrap gap-3">
      {socialItems.map(({ label, icon: Icon, key, handle }) => (
        <a
          key={key}
          href={siteData.business.socials[key]}
          target="_blank"
          rel="noopener noreferrer"
          className="group inline-flex items-center gap-2.5 px-4 py-2.5 bg-slate-900 border border-slate-800 rounded-sm hover:border-blue-500/60 hover:bg-slate-800 transition-all duration-200"
        >
          <Icon className="text-blue-500 text-base flex-shrink-0" />
          <div className="flex flex-col leading-none">
            <span className="text-white text-xs font-bold uppercase tracking-wide">{label}</span>
            <span className="text-slate-500 text-xs mt-0.5">{handle}</span>
          </div>
        </a>
      ))}
    </div>
  );
}